module.exports = __webpack_public_path__ + "static/media/18ECA25.544dd7cf.jpg";